export default __webpack_public_path__ + "static/media/school-bus.497f041e.svg";